$mol_status $mol_view
	status <= title
	minimal_height 24
	minimal_width 0
	sub /
		<= message \
